import React from 'react';
import {Modal} from 'react-bootstrap';
import {Trans} from 'react-i18next';

export default function ConfigurationModal({modalState, onClose}) {
  const {isShow, type, customDesc, showFooter} = modalState;

  const modalConfig = {
    processingInProgress: {
      title: (
        <Trans i18nKey="p.s.uiconfiguration.processing.in.progress.title">
          Processing in Progress
        </Trans>
      ),
      content: (
        <p>
          <Trans i18nKey="p.s.uiconfiguration.processing.in.progress.desc">
            The system is currently processing. Please wait until the process is
            complete before saving changes.
          </Trans>
        </p>
      ),
    },
    unsavedChanges: {
      title: (
        <Trans i18nKey="p.s.uiconfiguration.unsaved.changes.title">
          You Have Unsaved Changes
        </Trans>
      ),
      content: (
        <Trans i18nKey="p.s.uiconfiguration.unsaved.changes.desc">
          Please save before exporting the HTML file.
        </Trans>
      ),
    },
    outdatedConfig: {
      title: (
        <Trans i18nKey="p.s.uiconfiguration.outdated.config.title">
          Export Not Available for This UI Config Version
        </Trans>
      ),
      content:
        customDesc || (
          <Trans i18nKey="p.s.uiconfiguration.outdated.config.desc">
            To export your UI as HTML, you'll need to upgrade your config
            version. Just click <b>Save</b> to update — no edits to your current
            settings are required.
          </Trans>
        ),
    },
  };

  const config = modalConfig[type];

  if (!config) {
    return null;
  }

  return (
    <Modal show={isShow} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{config.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{config.content}</Modal.Body>
      {showFooter && (
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onClose}
          >
            <Trans i18nKey="p.p.s.view.close">Close</Trans>
          </button>
        </Modal.Footer>
      )}
    </Modal>
  );
}